var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogout(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "shortcut-icon",
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.458,
    height: 17.379,
    viewBox: "0 0 18.458 17.379",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_65257",
    "data-name": "Path 65257",
    d: "M17.507.554,16.93,8.629,14.273,6.376A7.129,7.129,0,0,0,9.691,12.95C6.995,8.9,8.57,5.38,11.562,3.041L9.757.451l7.75.1ZM4.251,0H6.437V2.954H4.907a2.29,2.29,0,0,0-2.28,2.281l0,6.909A2.3,2.3,0,0,0,3.3,13.753a2.275,2.275,0,0,0,1.609.673h8.714A2.3,2.3,0,0,0,15.9,12.145V11.1h2.555v1.7a5.059,5.059,0,0,1-1.25,3.328,4.243,4.243,0,0,1-3,1.25H4.251A4.267,4.267,0,0,1,0,13.129L0,4.252A4.254,4.254,0,0,1,4.251,0Z",
    fill: "#000",
    fillRule: "evenodd"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/logout.bfac69dbf00e86c11c42dd9fedcfa5a0.svg";
export { ForwardRef as ReactComponent };